import { render, staticRenderFns } from "./PackageQuoteList.vue?vue&type=template&id=2d4a61dc&"
import script from "./PackageQuoteList.vue?vue&type=script&lang=js&"
export * from "./PackageQuoteList.vue?vue&type=script&lang=js&"
import style0 from "./PackageQuoteList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PackageQuoteList.vue"
export default component.exports